module.exports = __webpack_public_path__ + "static/media/x5.b6dcae7c.jpeg";